import { render } from "./DkLogo.vue?vue&type=template&id=74dc2f65&scoped=true"
import script from "./DkLogo.vue?vue&type=script&lang=js"
export * from "./DkLogo.vue?vue&type=script&lang=js"

import "./DkLogo.vue?vue&type=style&index=0&id=74dc2f65&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74dc2f65"

export default script